import { BootstrapContext } from '@wix/wix-bootstrap-api';
import log from '@wix/wix-log';
import type { AspectStore } from '@wix/wix-aspects';
import { HttpClient } from '@wix/http-client';

export default function KeyValueAPI(
  ctx: BootstrapContext,
  aspects: AspectStore,
) {
  const httpClient = new HttpClient({
    baseURL: `https://bo.wix.com`,
  });

  async function setValue({
    key,
    value,
    ttlMillis,
  }: {
    key: string;
    value: any;
    ttlMillis?: number;
  }) {
    try {
      const { data } = await httpClient.post(
        `/_serverless/marketplace-key-value-store/setValue`,
        {
          key,
          value,
          ttlMillis,
        },
      );
      return data;
    } catch (e: any) {
      const { message, stack } = e;
      log('KeyValueAPI')
        .withAspects(aspects)
        .error(
          `error w/ marketplace-key-value-store/setValue ${message} ${stack}`,
        );
    }
  }

  async function getValue(key: string) {
    try {
      const { data } = await httpClient.post(
        `/_serverless/marketplace-key-value-store/getValue`,
        { key },
      );
      return data;
    } catch (e: any) {
      const { message } = e;
      log('KeyValueAPI')
        .withAspects(aspects)
        .error(
          `error w/ marketplace-key-value-store/getValue key:${key} message:${message}`,
        );
    }
  }

  async function deleteValue(key: string) {
    try {
      const { data } = await httpClient.delete(
        `/_serverless/marketplace-key-value-store/deleteValue/${key}`,
      );
      return data;
    } catch (e: any) {
      const { message, stack } = e;
      log('KeyValueAPI')
        .withAspects(aspects)
        .error(
          `error w/ marketplace-key-value-store/deleteValue/${key} ${message} ${stack}`,
        );
    }
  }

  return {
    setValue,
    getValue,
    deleteValue,
  };
}
